<template>

        <div class="login__form login-form">
            <form v-if="!local" method="GET" :action="route('saml2_login', {'idpName': samlLogin.idp_name})" autocomplete="off">
                <input type="hidden" name="_token" :value="csrf">

                <div class="login-form__title">
                    {{ trans('login.welcome_back')}}
                </div>

                <div class="login-form__meta">
                    {{ trans('login.saml.meta')}}
                </div>


                <button type="submit" class="btn btn--primary btn--login">
                    {{ trans('login.saml.login') }}
                </button>

                <div class="login-form__footer">
                    <a v-if="samlLogin.allow_local_login" href="#" v-on:click="toggleMode()">
                        {{ trans('login.saml.to_local') }}
                    </a>
                </div>
            </form>

            <form v-if="local" method="POST" :action="route('login')" autocomplete="off" class="filter-box" id="localLoginForm">
                <input type="hidden" name="_token" :value="csrf">

                <div class="login-form__title">
                    {{ trans('login.welcome_back')}}
                </div>

                <div class="login-form__meta">
                    {{ trans('login.meta')}}
                </div>
                <div class="login-form__input">
                    <input id="username" type="text" :class="['form-error',  errors.length ? 'form-error--is-invalid' : '']" :placeholder="trans('login.label.email')" name="username" :value="old['username']" :autofocus="true" required>
                </div>

                <div class="login-form__input">
                    <input id="password" type="password" :class="['form-error',  errors.length ? 'form-error--is-invalid' : '']" :placeholder="trans('login.label.password')" name="password" required>

                    <div v-if="'username' in errors" class="form-error form-error--login" role="alert">
                        <strong>{{ errors['username'][0] }}</strong>
                    </div>
                    <div v-if="'password' in errors" class="form-error form-error--login" role="alert">
                        <strong>{{ errors['password'][0] }}</strong>
                    </div>
                </div>

                <button type="submit" class="btn btn--primary btn--login">
                    {{ trans('login.login') }}
                </button>

                <div class="login-form__footer">
                    <a :href="route('password.request')">
                        {{ trans('login.forgot_password') }}
                    </a>
                </div>
                <div class="login-form__footer">
                    <a v-if="samlLogin.allow_local_login" href="#" v-on:click="toggleMode()">
                        {{ trans('login.saml.to_saml') }}
                    </a>
                </div>

            </form>
        </div>
</template>

<script>

export default {
    props: [
        'samlLogin',
        'errors',
        'old',
        'csrf'
    ],

    data() {
        return {
            'local': false
        };
    },

    created() {
    },

    mounted() {
    },

    methods: {
        toggleMode: function() {
            this.local = !this.local;
        }
    },
};
</script>
